import { TFunction } from "next-i18next";

import { PageContentProps } from "content/content.types";

import defaultContent from "./common";

const pageContent = (t: TFunction, { locale }: PageContentProps) =>
    defaultContent(t, { locale });

export default pageContent;
